import { ReactNode } from 'react';

import styles from './StepItem.module.css';

const StepItem = ({
    title,
    caption,
    action
}: {
    title: ReactNode;
    caption?: ReactNode;
    action: ReactNode;
}) => {
    return (
        <>
            <div className={styles.stepMessages}>
                <span className={styles.title}>{title}</span>
                <span className={styles.caption}>{caption}</span>
            </div>
            {action}
        </>
    );
};

// eslint-disable-next-line import/no-default-export
export default StepItem;
